 <template>
   <div id="app" :class="isAdminRoute ? 'min-h-screen bg-gray-100' : 'min-h-screen bg-gray-50'">
     <!-- Loading Screen -->
     <LoadingScreen v-if="isLoading" :show="isLoading" />
     
     <!-- Navigation - Only for non-admin routes -->
     <AppHeader v-if="!isAdminRoute" />
     
     <!-- Main Content -->
     <!-- 后台点击菜单项时会重新加载整个页面，经排查，此处
       <component :is="Component" :key="route.path" />
      这个 key 会导致 Vue 在路由切换时强制重新创建整个组件树，
      而不是仅仅更新内容区域。 -->
    
     <main>
       <RouterView v-slot="{ Component }">      <!-- , route -->
         <Transition name="page" mode="out-in">
           <component :is="Component" />
         </Transition>
       </RouterView>
     </main>
     
     <!-- Footer - Only for non-admin routes -->
     <AppFooter v-if="!isAdminRoute" />
     
     <!-- Back to Top Button - Only for non-admin routes -->
     <BackToTop v-if="!isAdminRoute" />
     
     <!-- Global Search Modal - Only for non-admin routes -->
     <SearchModal v-if="!isAdminRoute" />
   </div>
 </template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import LoadingScreen from '@/components/ui/LoadingScreen.vue'
import BackToTop from '@/components/ui/BackToTop.vue'
import SearchModal from '@/components/ui/SearchModal.vue'

const route = useRoute()
const isLoading = ref(false)

// 判断是否为管理后台路由
const isAdminRoute = computed(() => {
  return route.path.startsWith('/admin')
})

onMounted(() => {
  // Simulate loading time
  setTimeout(() => {
    isLoading.value = false
  }, 1500)
})
</script>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>